<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<talent-info pageName="clueSeas" :row="row" @goDetail="showDetailDrawer"></talent-info>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import talentInfo from '../../../components/talentInfo';
export default {
	components: {
		talentInfo,
	},
	inject: ['showDetailDrawer'],
	mixins: [mixin],
};
</script>
<style lang="less" scoped></style>
